"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rows = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _Cell = require("../Cell");
var _Row = require("../Row");
const isRowLabelPrimary = row => Object.prototype.hasOwnProperty.call(row, 'labelPrimary');
const isRowLabel = row => Object.prototype.hasOwnProperty.call(row, 'label');
const Rows = _ref => {
  let {
    rows = [],
    areDifferencesHighlighted,
    cellClassName
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, rows.map(row => {
    if (isRowLabelPrimary(row)) {
      return /*#__PURE__*/_react.default.createElement(_Row.Row, {
        isLabel: true,
        isPrimary: true,
        key: row.id
      }, row.labelPrimary);
    }
    if (isRowLabel(row)) {
      return /*#__PURE__*/_react.default.createElement(_Row.Row, {
        isLabel: true,
        key: row.id
      }, row.label);
    }
    if (!row.cells || !row.cells.filter(_ref2 => {
      let {
        values
      } = _ref2;
      return values.length;
    }).length) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_Row.Row, {
      hasHover: true,
      isHighlighted: areDifferencesHighlighted && row.hasDifferences,
      key: (0, _key.createKey)(row.id)
    }, row.cells.map(cell => /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
      id: cell.id,
      key: cell.id,
      className: cellClassName
    }, cell.values.map(value => /*#__PURE__*/_react.default.createElement("div", {
      key: (0, _key.createKey)(cell.id, value || '')
    }, value)))));
  }));
};
exports.Rows = Rows;
//# sourceMappingURL=Rows.js.map